import { auditReports } from '@mi-front/api-clients';
import { Alert, AlertTitle, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { ReprocessAction } from './ReprocessAction';
import { ReprocessCompletion } from './ReprocessCompletion';
import { ReprocessProgress } from './ReprocessProgress';

interface Props {
  run: auditReports.AodRun;
  isDisabled: boolean;
  isLoading: boolean;
  executeAction: (promise: Promise<unknown>) => void;
}

export function ReprocessRun({ run, isDisabled, isLoading, executeAction }: Props) {
  const { $t } = useIntl();
  const reprocessMutation = auditReports.useTriggerReprocessRunActions();

  const handleReprocess = () => {
    executeAction(
      reprocessMutation.mutateAsync({
        id: run.id,
      }),
    );
  };

  const isReprocessed = run.userStatus === auditReports.AodRunUserStatusEnum.REPROCESSED;

  if (!run.canReprocess && !isReprocessed) {
    return null;
  }

  return (
    <Alert severity="warning">
      <AlertTitle>
        {$t({
          id: 'audit.aod.actions.triggerReprocess',
          defaultMessage: 'Reprocesar',
        })}
      </AlertTitle>
      <Box display="flex" flexDirection="column" gap={2}>
        <ReprocessProgress run={run} />
        <ReprocessCompletion run={run} />
        <ReprocessAction
          run={run}
          isDisabled={isDisabled}
          isLoading={isLoading}
          onReprocess={handleReprocess}
        />
      </Box>
    </Alert>
  );
}
